( function ( $ ) {
	
	$( document ).ready( function() {
		
		$( document ).foundation();
		new WOW().init();
		
		$('#mobmen').css('paddingTop', $('#HeaderMobile').outerHeight()+'px');
		
	} );
	
	$( '.infinitescroll' ).infiniteScroll( {
		path: ( $( 'body' ).hasClass( 'single' ) ) ? function(){ return $( '.post-navigation:last > .next-post > a' ).attr( 'href' ); } : '.posts-pagination > .navigation > ul > li.next-post > a',
		append: '.append',
		scrollThreshold: 650,
		history: 'push',
		historyTitle: true,
		hideNav: false,
		debug: false,
		onInit: function() {
			this.on(
				'append',
				function() {

					// console.log('Infinete scroll append triggered.');

					$('.infinitescroll img[data-interchange]:not([src])').each(function (idx, el) {

						var rules = $(el).data('interchange').split('], ');

						for(var i=0; i < rules.length; i++) {
							rules[i]  = rules[i] + ']';
						}
						
						// console.log('Interchange image.', el, rules);

						new Foundation.Interchange(
							$(el),
							{
								rules: rules
							}
						);

					});
				}
			)
		}
	} );
	
} )( jQuery );
